import { render, staticRenderFns } from "./japan.vue?vue&type=template&id=07479ba2&"
import script from "./japan.vue?vue&type=script&lang=js&"
export * from "./japan.vue?vue&type=script&lang=js&"
import style0 from "./japan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports